import { render, staticRenderFns } from "./LoaderRing.vue?vue&type=template&id=7e486e32&"
import script from "./LoaderRing.vue?vue&type=script&lang=js&"
export * from "./LoaderRing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports